import { jsxs, jsx } from 'react/jsx-runtime';
import { useContextAccessToken } from '../../../permission/contexts/AnonShareTokenContext.js';
import { useResourceDataContextSafe } from '../context/resourceDataContext.js';
import { MemberBarResourcerWithLiveBlocks } from '../../../multiplayer/components/MemberBar/MemberBarResourceWithLiveBlock.js';
import { isResourceIntegrationItem } from '../../../resources/utils/resourceDetailGuards.js';
import { resourceSharingModal } from '../../../permission/components/ModalShare/resourceSharingStore.js';
import { Flex } from '@fabric-app/ui/components/Flex';
import { styled } from 'styled-components';
import { ButtonShowSimilar } from '../ButtonShowSimilar.js';

const ResourceSidebarHeader = ({ isFullscreen, handleClose }) => {
  const accessToken = useContextAccessToken();
  const { resource, disabledActions } = useResourceDataContextSafe();
  if (isFullscreen || accessToken) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Container, {
    children: [
      !accessToken && !isFullscreen && /* @__PURE__ */ jsx(ButtonShowSimilar, {
        resource,
        onClick: handleClose
      }),
      !accessToken && !isFullscreen && !resource.isDraft && !isResourceIntegrationItem(resource) ? /* @__PURE__ */ jsx(MemberBarResourcerWithLiveBlocks, {
        barColorScheme: "dark",
        resourceId: resource.id,
        renderShareButtonOutside: true,
        isPublicShared: resource.isShared || false,
        onOpenShareModal: disabledActions.manageSomePermissionRoles ? void 0 : () => resourceSharingModal.open({
          resourceId: resource.id
        })
      }) : null
    ]
  });
};
const Container = styled(Flex).attrs((p) => {
  return {
    gap: 10,
    alignItems: "center",
    justifyContent: "flex-end",
    ...p
  };
}).withConfig({
  displayName: "ResourceSidebarHeader__Container",
  componentId: "sc-7a91e6a6-0"
})([
  ``
]);

export { ResourceSidebarHeader };
//# sourceMappingURL=ResourceSidebarHeader.js.map
